/**
 * Directional jump down gesture
 * @module gestures/transforms/jumpDown
 */
import { createJumpGesture } from './jumpFactory.js';
export default createJumpGesture('down');
